import { useTheme } from '@emotion/react';
import {
  IconBallAmericanFootball,
  IconBallBaseball,
  IconBallBasketball,
  IconBallFootball,
  IconGolf,
  IconIceSkating,
} from '@tabler/icons-react';

import IconCards from '~/domains/design-system/icons/IconCards';

export function IconMapByLeague({ leagueId, size, ...props }: { leagueId: string; size: number }) {
  const theme = useTheme();

  switch (leagueId) {
    case 'popular':
      return <IconCards color={theme.colors.blue[4]} size={size + 2} />;
    case 'pga':
      return <IconGolf color={theme.colors.blue[4]} size={size} {...props} />;
    case 'soccer':
      return <IconBallFootball color={theme.colors.blue[4]} size={size} {...props} />;
    case 'nfl':
    case 'ncaaf':
      return <IconBallAmericanFootball color={theme.colors.blue[4]} size={size} {...props} />;
    case 'mlb':
      return <IconBallBaseball color={theme.colors.blue[4]} size={size} {...props} />;
    case 'nba':
    case 'ncaab':
      return <IconBallBasketball color={theme.colors.blue[4]} size={size} {...props} />;
    case 'nhl':
      return <IconIceSkating color={theme.colors.blue[4]} size={size} {...props} />;
    default:
      return null;
  }
}
